import { Box } from '@chakra-ui/react';

import { Condition, Iteration } from 'Component/others';
import { TextRegular, TextSemiBold } from 'UiKit/typography';

import { useBriefLiveState } from 'View/brief-live/state';

import styles from './styles.module.css';

const UsedStockColumn = ({ value }) => {
  const { state, updateState } = useBriefLiveState();
  return (
    <Box className={styles['used-stock-column__container']}>
      <Condition
        statement={value && value?.length > 0}
        fallback={
          <Box className={styles['used-stock-column__box--item']}>
            <TextRegular className={styles['used-stock-column__text']}>-</TextRegular>
          </Box>
        }
      >
        <Iteration
          items={value?.filter((_, index) => index < 3)}
          render={(prize) => {
            return (
              <Box className={styles['used-stock-column__box--item']}>
                <Box className={styles['used-stock-column__row']}>
                  <TextRegular className={styles['used-stock-column__text']}>{prize.usedStock}</TextRegular>
                  <Condition statement={prize.usedStock > 0}>
                    <TextSemiBold
                      className={styles['used-stock-column__link']}
                      fontSize="var(--font-body3)"
                      color="var(--color-primary50)"
                      onClick={() => {
                        updateState({
                          isOpenModalDetailWinner: true,
                          isOpenModalPrizeList: false,
                          detailWinnerPreviousModal: state.isOpenModalPrizeList ? 'isOpenModalPrizeList' : null,
                          selectedGiveawayId: prize.id,
                        });
                      }}
                    >
                      lihat detail &gt;
                    </TextSemiBold>
                  </Condition>
                </Box>
              </Box>
            );
          }}
        />
      </Condition>
    </Box>
  );
};

export default UsedStockColumn;
